import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { objectToCamel, objectToSnake } from 'ts-case-convert';
import { IBasicTemporalPass, ITemporalPass, ITemporalPassRequest } from 'src/app/models';
import { TemporalPassesHttpService } from './temporal-passes.http.service';

@Injectable({
  providedIn: 'root'
})
export class TemporalPassesService {

  constructor(private temporalPassesHttpService: TemporalPassesHttpService) { }

  private extractList(data: any): IBasicTemporalPass[] {
    const inner = data && !Array.isArray(data) && 'data' in data ? data.data : data;
    if (Array.isArray(inner)) return inner;
    if (inner && Array.isArray(inner.content)) return inner.content;
    console.warn('Unexpected temporal passes response shape:', data);
    return [];
  }

  async getTemporalPasses(page?: number, size?: number, name?: string, fareIds?: number[]): Promise<IBasicTemporalPass[]> {
    const source$ = this.temporalPassesHttpService.getTemporalPasses(page, size, name, fareIds);
    const response = await lastValueFrom(source$);
    const data = objectToCamel(response as object) as any;
    return this.extractList(data);
  }

  async getTemporalPass(id: number): Promise<ITemporalPass> {
    const source$ = this.temporalPassesHttpService.getTemporalPass(id);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as ITemporalPass;
  }

  async createTemporalPass(temporalPass: ITemporalPassRequest): Promise<ITemporalPass> {
    const requestBody = objectToSnake(temporalPass);
    const source$ = this.temporalPassesHttpService.createTemporalPass(requestBody);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as ITemporalPass;
  }

  async updateTemporalPass(id: number, temporalPass: ITemporalPassRequest): Promise<ITemporalPass> {
    const requestBody = objectToSnake(temporalPass);
    const source$ = this.temporalPassesHttpService.updateTemporalPass(id, requestBody);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as ITemporalPass;
  }

  async deactivateTemporalPass(id: number): Promise<void> {
    const source$ = this.temporalPassesHttpService.deactivateTemporalPass(id);
    await lastValueFrom(source$);
  }

  async activateTemporalPass(id: number): Promise<void> {
    const source$ = this.temporalPassesHttpService.activateTemporalPass(id);
    await lastValueFrom(source$);
  }
}
